module.exports = __webpack_public_path__ + "assets/media/youtubeIcon.be2447a7.svg";